import React, { createContext, useState, useContext } from 'react';

const ModuleContext = createContext();

export const useModule = () => {
  return useContext(ModuleContext);
};

export const ModuleProvider = ({ children }) => {
  const [currentModuleTitle, setCurrentModuleTitle] = useState(null);
  const [currentModuleSubtitle, setCurrentModuleSubtitle] = useState(null);

  const value = {
    currentModuleTitle,
    setCurrentModuleTitle,
    currentModuleSubtitle,
    setCurrentModuleSubtitle,
  };

  return (
    <ModuleContext.Provider value={value}>
      {children}
    </ModuleContext.Provider>
  );
};